import { FC } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ButtonLink } from './ButtonLink';
import { SectionType, ICustomPageSection } from '../../models';

interface IAccordionSection {
  section: ICustomPageSection;
}

export const AccordionSection: FC<IAccordionSection> = ({ section }) => {
  const classes = useStyles();
  return (
    <div className={classes.accordionSection}>
      <Accordion>
        <AccordionSummary className={classes.accordionHeader} expandIcon={<ExpandMore />}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {section.name}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container justifyContent="space-around" spacing={2}>
            {section.sections?.map((ss, index) => {
              if (ss.type === SectionType.BUTTON_LINK) {
                return (
                  <Grid item xs={12} sm={6} key={`${index}`}>
                    <ButtonLink section={ss} />
                  </Grid>
                );
              } else {
                return <></>;
              }
            })}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const useStyles = makeStyles<Theme>(theme => ({
  accordionSection: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '75%'
    }
  }
}));
